import jalaali from "jalaali-js";

export function getRowStyle(condition) {
    switch (condition) {
        case "منتشر شده":
            return { backgroundColor: "#d4edda" };
        case "آگهی جدید":
            return { backgroundColor: "#fff3cd" };
        case "آگهی اصلاح شده":
            return { backgroundColor: "#fff3cd" };
        case "نیازمند اصلاح":
            return { backgroundColor: "#f8d7da" };
        default:
            return {};
    }
}


export function toPersianDate(dateString) {
    const date = new Date(dateString);
    const j = jalaali.toJalaali(date);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${j.jy}/${j.jm}/${j.jd} ${hours}:${minutes}`;
}
export function toPersianDigits(input) {
    if (!input) return "";
    return String(input).replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
}
